import { Modal, ModalContent, ModalFooter, Box, ModalOverlay } from '@chakra-ui/react';
import { Text, Button } from '@mercator-gcp/grout';

const titleStyle = {
  paddingBottom: 'padding_16',
};

const modalBodyStyle = {
  padding: 'padding_16',
  paddingBottom: '0px',
};

const modalFooterStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  padding: 'padding_16',
};

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const ConfirmUnsaveModal = ({ isOpen, onClose, onConfirm }: ModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <Box sx={modalBodyStyle}>
          <Text.Lead sx={titleStyle}>Remove project from lead list</Text.Lead>
          <Text>Are you sure you want to remove this project from your lead list?</Text>
        </Box>

        <ModalFooter sx={modalFooterStyle}>
          <Button variant="functional" onClick={onClose}>
            No, cancel
          </Button>
          <Button variant="alert" onClick={onConfirm}>
            Remove from lead list
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ConfirmUnsaveModal;
